import React, { useState } from "react";
import { STAccordion, STButton, STDrawer, STHeroCommon } from "../";
import styles from "./STOurTechnology.module.css";
import { Icons } from "@/const/icons";
import Image from "next/image";
import {
  BioMaterialImg,
  emissionsImpactImg,
  safGuideImg,
  SustainableFuleImg,
} from "@/assets/images";
import clsx from "clsx";
import { bioCoatingData, faqData, newsFeedData } from "@/const/data";
import Link from "next/link";

export const STOurTechnology = () => {
  const [bioCoatingDrawerOpen, setBioCoatingDrawerOpen] = useState(false);
  const [waterLessCoatingDrawerOpen, setWaterLessCoatingDrawerOpen] =
    useState(false);
  const [emissionsImpactDrawerOpen, setEmissionsImpactDrawerOpen] =
    useState(false);
  return (
    <>
      <STHeroCommon
        title={"Barrier coatings for paper"}
        description={
          "High-performance Water, Grease & Water Vapour barrier for paper via a single-layer coating; engineered from agricultural biomass and seamlessly applied using existing coating machine lines."
        }
      />
      {/*  SUSTAINABLE FUEL SECTION START */}
      <section
        className={clsx(
          styles.sustainableFuleSection,
          "position-relative space-xl-pt",
        )}
      >
        <div className="container">
          <div
            className={clsx(
              styles.sustainableFuleWrapper,
              "d-flex gap-md justify-content-between align-items-center flex-column-reverse flex-lg-row",
            )}
          >
            <div
              className={clsx(
                styles.sustainableFuleContent,
                "d-flex flex-column align-items-start",
              )}
            >
              <h2 className="primary-title text-clr-gray mb-0">
                Bio-coating for{" "}
                <span className="text-clr-black">
                  food contact paper packaging
                </span>
              </h2>
              <p className="paragraph-text space-sm-mt space-md-mb">
                Delivering high barrier performance to paper with proven
                recyclability, food-contact safety, and metal-free, PFAS-free,
                zero-microplastic technology; engineered to reduce grammage,
                ensure PPWR compliance, and optimize ultra-low grammage flexible
                packaging.
              </p>
              <STButton
                suffix={Icons.arrowDoubleRightIcon}
                variant="outline-primary"
                onClick={() => setBioCoatingDrawerOpen(true)}
              >
                Learn more
              </STButton>
            </div>
            <div
              className={clsx(
                styles.sustainableFuleImageWrapper,
                "rounded-circle d-flex align-items-center justify-content-center flex-shrink-0",
              )}
            >
              <Image
                src={SustainableFuleImg}
                alt="sustainable fuel"
                className="rounded-circle object-cover"
              />
            </div>
          </div>
        </div>
      </section>
      {/*  SUSTAINABLE FUEL SECTION END */}

      {/* BIO COATING SECTION START */}
      <section
        className={clsx(
          styles.bioCoatingSection,
          "position-relative space-xl-pt",
        )}
      >
        <div className="container">
          <div className="text-center">
            <h2 className="primary-title  mb-0">
              Shunya™ barrier bio coating:
            </h2>
            <h2 className="primary-title text-clr-gray mb-0">
              no green premium, sheer performance
            </h2>
          </div>

          <div
            className={clsx(
              styles.bioCoatingCardWrapper,
              "d-grid gap-sm space-lg-mt",
            )}
          >
            {bioCoatingData.map((item, index) =>
              item.type === "image" ? (
                <div
                  key={index}
                  className={clsx(
                    styles.imageItem,
                    "radius-lg overflow-hidden position-relative ratio",
                  )}
                >
                  <Image
                    src={item.src}
                    alt={item.alt}
                    fill
                    className="object-fit-cover"
                  />
                </div>
              ) : (
                <div
                  key={index}
                  className={clsx(
                    styles.bioCoatingItem,
                    "radius-lg bg-off-white",
                  )}
                >
                  <Image
                    src={item.icon}
                    alt=""
                    width={72}
                    height={72}
                    className={clsx("space-md-mb", styles.bioCoatingIcon)}
                  />
                  <p className={"secondary-title mb-0 h5"}>{item.text}</p>
                </div>
              ),
            )}
          </div>
        </div>
      </section>
      {/* BIO COATING SECTION END */}

      {/* SAF GUIDE SECTION START */}
      <section
        className={clsx(
          styles.safGuideSection,
          "position-relative space-xl-py",
        )}
      >
        <div className="container">
          <div
            className={clsx(
              styles.safGuideWrapper,
              "d-flex gap-md justify-content-between align-items-center flex-column flex-lg-row",
            )}
          >
            <div
              className={clsx(
                styles.safGuideImageWrapper,
                "rounded-circle d-flex align-items-center justify-content-center flex-shrink-0",
              )}
            >
              <Image
                src={safGuideImg}
                alt="sustainable fuel"
                className="rounded-circle object-cover"
              />
            </div>
            <div
              className={clsx(
                styles.safGuideContent,
                "d-flex flex-column align-items-start",
              )}
            >
              <h2 className="primary-title mb-0">
                Waterless coating system{" "}
                <span className="text-clr-gray">is the future</span>
              </h2>
              <p className="paragraph-text space-sm-mt space-md-mb">
                In a water-dispersed coating, evaporation of water requires huge
                amounts of power up-to 3.3 GWh per assembly line per year. Btw,
                65% of gross weight of the coating is water.
              </p>
              <STButton
                suffix={Icons.arrowDoubleRightIcon}
                variant="outline-primary"
                onClick={() => setWaterLessCoatingDrawerOpen(true)}
              >
                Learn more
              </STButton>
            </div>
          </div>
        </div>
      </section>
      {/* SAF GUIDE SECTION END */}

      {/* EMISSIONS IMPLACT SECTION START */}
      <section>
        <div className="container">
          <div
            className={clsx(
              styles.emissionsImpactWrapper,
              "radius-xl space-sm-p d-flex flex-column-reverse flex-lg-row bg-off-white justify-content-between align-items-lg-center gap-md",
            )}
          >
            {/* content */}
            <div className={clsx(styles.emissionsImpactContent)}>
              <h2 className={clsx(styles.emissionsImpactvalue, "mb-0")}>
                -83%
              </h2>
              <p className="h6 big text-clr-gray fw-normal lh-base space-lg-mb">
                CO2 emissions (Scope 1 & 3) & water saved with Sustanix’s 100%
                bio-based solid coating system compared to other water-based
                formulations
              </p>
              <STButton
                suffix={Icons.arrowDoubleRightIcon}
                onClick={() => setEmissionsImpactDrawerOpen(true)}
              >
                Click to compare emission
              </STButton>
            </div>
            {/* image */}
            <div
              className={clsx(
                styles.emissionsImpactImageWrapper,
                "ratio ratio-1x1 radius-sm overflow-hidden bg-gray-shimmer",
              )}
            >
              {/* <Image
                src={emissionsImpactImg}
                alt="emissions impact"
                className="object-cover"
              /> */}
              <video
                src="/video/technology_compare_emission.mp4"
                autoPlay
                muted
                loop
                playsInline
                controls={false}
                disablePictureInPicture
                style={{ pointerEvents: "none" }}
                className={clsx(
                  styles.heroVideo,
                  "w-100 h-100 object-fit-cover",
                )}
              ></video>
            </div>
          </div>
        </div>
      </section>
      {/* EMISSIONS IMPLACT SECTION END */}

      {/*  INSIGHTS SECTION START */}
      <section className={clsx(styles.insightsSection, "space-xl-py")}>
        <div className="container">
          <div className={clsx(styles.insightsCardWrapper, "d-grid gap-sm")}>
            {newsFeedData.slice(0, 6).map((item) => (
              <Link
                key={item.id}
                href={`/news-feed/${item.slug}`}
                className={clsx(
                  styles.insightsCard,
                  "bg-off-white space-xs-p radius-md d-block text-decoration-none",
                )}
              >
                <div
                  className={clsx(
                    styles.insightsImageWrap,
                    "ratio radius-sm overflow-hidden bg-clr-white",
                  )}
                >
                  <Image
                    src={item.image}
                    alt={item.title}
                    fill
                    className="transition-smooth object-fit-contain"
                  />
                </div>

                <p
                  className={clsx(
                    "secondary-title mb-0 space-xs-pt h6",
                    styles.insightsCardTitle,
                  )}
                >
                  {item.title}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </section>
      {/*  INSIGHTS SECTION END */}
      {/* FAQ STACTION START */}
      <section className="space-xl-py bg-black ">
        <div className="container">
          <div className="d-flex flex-column flex-xl-row align-items-center gap-md">
            <div className="w-100">
              <h2 className="primary-title text-white mb-0">FAQs...</h2>
              <h2 className="primary-title text-clr-gray-55 mb-0">
                Got questions? find your answers right here
              </h2>
            </div>
            <div className="w-100">
              <STAccordion defaultOpen={1} items={faqData} isDark />
            </div>
          </div>
        </div>
      </section>
      {/* FAQ STACTION END */}

      {/* Bio Coating Drawer Start */}
      <STDrawer
        open={bioCoatingDrawerOpen}
        onClose={() => setBioCoatingDrawerOpen(false)}
      >
        <p className="paragraph-text h6 space-xs-mb">
          Our high-performance coatings require less thickness to achieve the
          same protective results as traditional plastics, leading to a 15–20%
          reduction in material usage and direct savings in logistics and
          shipping weights.
        </p>
        <p className="paragraph-text h6 space-xs-mb">
          The mono-material mono-layer coating already provides Water, Grease &
          Water Vapour barrier which is currently unheard off in bio-coating
          systems. Additionally, research is ongoing for another layer of
          coating providing very high oxygen barrier.
        </p>
        <p className="paragraph-text h6 space-xs-mb">
          The coating is also designed to work on both inline and offline
          systems thereby both paper manufacturers and convertors can implement
          the system at their ends.
        </p>
        <p className="paragraph-text h6 mb-0">
          It has already been tested for coating ultra-low GSM paper of 22 and
          upto 280 GSM, thereby clearly proving it s versatality.
        </p>
      </STDrawer>
      {/* Bio Coating Drawer End */}

      {/* Waterless Coating Drawer Start */}
      <STDrawer
        open={waterLessCoatingDrawerOpen}
        onClose={() => setWaterLessCoatingDrawerOpen(false)}
      >
        <p className="paragraph-text h6 space-xs-mb">
          Water Savings: The Physical Load
        </p>
        <p className="paragraph-text h6 space-xs-mb">
          Based on the transition from a 40% solids aqueous dispersion to the
          100% solid Sustanix system, the calculation for water removal per
          industrial line is as follows:
        </p>
        <ul className="list space-xs-mb">
          <li className="mb-2 paragraph-text h6">
            Dry Coating Target: 8 g/m2 (0.008  kg/m2).
          </li>
          <li className="mb-2 paragraph-text h6">
            Aqueous Mix Requirement: To achieve 8 grams of dry solids from a 40%
            dispersion, 20 gram of "wet" coating must be applied (0.008 / 0.40).
          </li>
          <li className="mb-0 paragraph-text h6">
            Water Load per m2: 20 g (Wet) - 8 g (Dry) = 12 g of water.
          </li>
        </ul>
        <p className="paragraph-text h6 space-xs-mb">Annual Water Savings:</p>
        <ul className="list space-xs-mb">
          <li className="mb-2 paragraph-text h6">
            <span className="text-black">Hourly water savings:</span> 38,400
            m2/0.012 kg/m2 = 460.8 kg/h.
          </li>
          <li className="mb-0 paragraph-text h6">
            <span className="text-black">Yearly water savings(6,000h):</span>{" "}
            460.8 kg/h x 6,000 h ={" "}
            <span className="text-black">2,764,800 kg/year.</span>
          </li>
        </ul>
        <p className="paragraph-text h6 mb-0">
          Result: One single assembly line switching to Sustanix saves 2,765
          tonnes of freshwater annually—water that currently evaporates into the
          atmosphere as waste.
        </p>
      </STDrawer>
      {/* Waterless Coating Drawer End */}

      {/* Emissions Impact Drawer Start */}
      <STDrawer
        open={emissionsImpactDrawerOpen}
        onClose={() => setEmissionsImpactDrawerOpen(false)}
      >
        <p className="paragraph-text h6 space-xs-mb">
          Water Mass to Evaporate: To achieve 8 g/m2 dry weight from a 40% solid
          dispersion, a mill must apply 20 g/m2 of wet coating—meaning 12 g of
          water per square meter must be evaporated.
        </p>
        <p className="paragraph-text h6 space-xs-mb">
          Hourly Water Load: 38,400 m2/hour x 0.012 kg = 460 kilogram of
          water/hour Specific Energy Demand: Evaporating water at 100o C (feed
          temp 25o C) with an Infrared (IR) drying efficiency of 60% requires
          approximately 1.19 kWh per kg of water.
        </p>
        <p className="paragraph-text h6 space-xs-mb">
          Annual Energy Consumption: 460.8 kg/h x 1.19 kWh/kg x 6,000 hour = 3.3
          GWh per year. 3.3 GWh = 3,300,000 kWh, 3,300,000×0.475=
          <span className="text-black">1,567,500 kg CO₂</span>
        </p>

        <p className="paragraph-text h6 space-xs-mb">
          Industrial drying and ventilation are the most carbon-intensive parts
          of the process. The carbon impact depends on whether the heat is
          generated via Natural Gas (common for dryers) or Grid Electricity (for
          fans and chillers).
        </p>
        <ul className="list space-xs-mb">
          <p className="paragraph-text mb-2 h6 text-black">
            1. Drying & Ventilation (The Bulk Consumption)
          </p>
          <li className="paragraph-text mb-2 h6">
            Energy Use: Approx. 2.97 GWh (90% of the total 3.3 GWh).
          </li>
          <li className="paragraph-text mb-2 h6">
            Source: Usually Natural Gas (Latent heat for evaporation).
          </li>
          <li className="paragraph-text mb-2 h6">
            Carbon Intensity: 0.20 kg CO2/kWh(Natural Gas).
          </li>
          <li className="paragraph-text mb-0 h6">
            Carbon Consumed: 2,970,000 kWh times 0.20 kg = 594 Tonnes of CO2
          </li>
        </ul>
        <ul className="list space-xs-mb">
          <p className="paragraph-text mb-2 h6 text-black">
            2. Cooling, Chilling & Controls
          </p>
          <li className="paragraph-text mb-2 h6">
            Energy Use: Approx. 0.33 GWh (10% of the total).
          </li>
          <li className="paragraph-text mb-2 h6">Source: Grid Electricity.</li>
          <li className="paragraph-text mb-2 h6">
            Carbon Intensity (EU Average): € 0.25 kg CO2 /kWh
          </li>
          <li className="paragraph-text mb-0 h6">
            Carbon Consumed: 330,000 kWh times 0.30 kg = 99 Tonnes of CO2
          </li>
        </ul>
        <p className="paragraph-text h6 space-xs-mb">
          Total Annual Carbon Impact
        </p>
        <p className="paragraph-text h6 space-xs-mb">
          Summing these up, the units you listed consume a total of:
        </p>
        <p className="paragraph-text h6 mb-0">
          Total Carbon Consumed:{" "}
          <span className="text-black">693 Tonnes of CO₂ per year.</span>
        </p>
      </STDrawer>
      {/* Emissions Impact Drawer End */}
    </>
  );
};
